import { Cell, flexRender, Row, Table, Header } from '@tanstack/react-table';
import { BouColor } from '@upright/ui/common/generic/global/bou-colors';
import { flatten } from 'lodash';
import styled from 'styled-components';
import { TableV2RenderProps } from '../../types';

// OA: A very quick'n'dirty table card logic, will need a lot of refinement.

export function TableCards<T extends object, ColumnId extends string>(
  props: TableV2RenderProps<T, ColumnId> & { table: Table<T> },
) {
  const { table } = props;
  const rows = table.getRowModel().rows;

  const headers = flatten(props.table.getHeaderGroups().map(hg => hg.headers));

  return (
    <Root>
      {rows.map(row => {
        return <TableCard key={row.id} {...{ row, headers }} />;
      })}
    </Root>
  );
}

const Root = styled.div``;

function TableCard<T extends object>(props: { row: Row<T>; headers: Array<Header<T, unknown>> }) {
  const { row, headers } = props;
  const cells = row.getAllCells();

  return (
    <CardRoot>
      {cells.map(cell => {
        return <TableCardCell key={cell.id} {...{ cell, headers }} />;
      })}
    </CardRoot>
  );
}

const CardRoot = styled.div`
  margin-bottom: 3em;
  border: 1px solid ${BouColor.TOOL_BORDER_DARK_GRAY};
  padding: 1em;
  box-shadow: 0 0.2em 1em rgba(0, 0, 0, 0.1);
`;

function TableCardCell<T extends object>(props: { cell: Cell<T, unknown>; headers: Array<Header<T, unknown>> }) {
  const { cell, headers } = props;
  const columnDef = cell.column.columnDef;
  const header = headers.find(h => h.column.columnDef.id === columnDef.id);

  return (
    <CellRoot>
      <Title>{header ? flexRender(header.column.columnDef.header, header.getContext()) : 'Unknown'}:</Title>
      <Value>{flexRender(columnDef.cell, cell.getContext())}</Value>
    </CellRoot>
  );
}

const CellRoot = styled.div`
  display: flex;
  margin-bottom: 0.5em;
`;

const Title = styled.div`
  margin-right: 1em;
  flex: 0 0 10em;
  font-weight: bold;
`;

const Value = styled.div``;
